export default __webpack_public_path__ + "6c1042b2d9fe98a832f9d0cb6a101ca7.png";